export default __webpack_public_path__ + "static/char-s-59-en-05444343146175a489e17db925858295.webp";